import lottie from 'lottie-web';

$.fn.isInViewport = function () {
	let elementTop = $(this).offset().top;
	let elementBottom = elementTop + $(this).outerHeight();
	let viewportTop = $(window).scrollTop();
	let viewportBottom = viewportTop + $(window).height();
	return elementBottom > viewportTop && elementTop < viewportBottom;
};

export const BrushStroke = (() => {
	'use strict';

	let lottieContainers,
		scroll_direction,
		buffer = false,
		scheduledAnimationFrame,
		lastScrollY = 0;

	function setVideoBgColor(vid) {
		const canvas = document.createElement('canvas');
		canvas.width = 8;
		canvas.height = 8;

		const ctx = canvas.getContext('2d');
		ctx.drawImage(vid, 0, 0, 8, 8);

		const p = ctx.getImageData(0, 0, 8, 8).data;
		const rgbString = `${p[60]},${p[61]},${p[62]}`;

		// vid.style.boxShadow = `0 0 50px rgb(${rgbString}), 0 0 100px rgb(${rgbString}), 0 0 200px rgb(${rgbString}), 0 0 400px rgb(${rgbString})`;
		// vid.style.boxShadow = '0 0 50px rgb(234, 200, 10), 0 0 100px rgb(234, 200, 10), 0 0 200px rgb(234, 200, 10), 0 0 400px rgb(234, 200, 10)';
	}

	function init() {
		document.querySelectorAll('.strokeBlockVideo > video').forEach((vidEl) => {
			vidEl.addEventListener('loadeddata', () => {
				console.log('loadeddata');
				setVideoBgColor(vidEl);
			});
			vidEl.addEventListener('loadedmetadata', () => {
				console.log('loadedmetadata');
				setVideoBgColor(vidEl);
			});
			vidEl.addEventListener('play', () => {
				console.log('play');
				setVideoBgColor(vidEl);
			});
		});

		if ($('.strokeBlockVideo').length) {
			$(window).on('load resize scroll', function () {
				$('.video-item').each(function () {
					if ($(this).isInViewport()) {
						if ($(this).attr('data-played') == 'false') {
							$(this)[0].play();
							$(this).attr('data-played', 'true');
						}
					}
				});
			});
		} else {
			lottieContainers = document.querySelectorAll('.lottie-brushstroke');

			if (lottieContainers) {
				lottieContainers.forEach(function (lottieContainer) {
					checkLotties(lottieContainer);
				});
			}

			events();
		}
	}

	function liveUpdates() {
		lottieContainers.forEach(function (lottieContainer) {
			checkLotties(lottieContainer);
		});
		scheduledAnimationFrame = false;
	}

	function onScroll(evt) {
		// Store the scroll value for laterz.
		lastScrollY = window.scrollY;

		// Prevent multiple rAF callbacks.
		if (scheduledAnimationFrame) {
			return;
		}

		scheduledAnimationFrame = true;
		requestAnimationFrame(liveUpdates);
	}

	function events() {
		window.addEventListener('scroll', onScroll);
	}

	function checkLotties(lottieContainer) {
		// don't mess with it until it matters
		if (isInViewport(lottieContainer)) {
			var $lottie = $(lottieContainer);

			// check if loaded, if not, load it up
			if (!$lottie.data('loaded')) {
				console.log('loading');
				loadLottieAnimation(lottieContainer);
			} else {
				var top = $lottie.data('top');
				var bottom = $lottie.data('bottom');

				// within the top + bottom
				// if ( lastScrollY > top && lastScrollY < bottom ) {
				var anim = $lottie.data('anim');
				var total_frames = $lottie.data('frame');
				var percentage = (lastScrollY - top) / bottom;
				var current_frame = Math.floor(percentage * total_frames);
				anim.goToAndStop(current_frame, true);
				// }
			}
		}
	}

	function isInViewport(el) {
		// return true;
		const rect = el.getBoundingClientRect();
		var elementTop = $(el).offset().top;
		var elementBottom = elementTop + $(el).outerHeight();
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height() + $(window).height() / 2;
		return elementBottom > viewportTop && elementTop < viewportBottom;
	}

	function loadLottieAnimation(el) {
		if (!$(el).data('loaded')) {
			var anim = lottie.loadAnimation({
				container: el,
				renderer: 'svg',
				loop: false,
				autoplay: false,
				path: el.dataset.json,
			});

			anim.addEventListener('DOMLoaded', function () {
				// anim.play();
				$(el).data('loaded', true);
				$(el).attr('data-top', $(el).offset().top);
				$(el).attr('data-bottom', $(el).offset().top + $(el).outerHeight() / 4);
				$(el).data('anim', anim);
			});
		}
	}

	return {
		init: init,
		name: 'brush-stroke',
	};
})();
